import { yoyoHttp } from '../services/http.service';
import { MUTATIONS, ACTIONS, CREATE_SHIPMENT_PREFIX, CORE_PREFIX } from './constants';
import { allBookingSystems } from '../data/headerData.js';
import { EventBus } from '../services/event-bus.js';
import { EVENTS } from '../store/nameConstants';
import { app } from '.././main';
import { authService } from '../msal';
import Vue from 'vue'

const actions = {
    async [ACTIONS.CORE.FETCH_NEWS](ctx) {
        const r = await yoyoHttp.get('/api/User/GetNews', {
            params: {
                userId: ctx.state.userData.id
            }
        });

        if (r.status === 200) {
            if (r.data.length > 0) {
                ctx.commit(MUTATIONS.CORE.SET_NEWS, r.data);
            }
        }
    },

    async [ACTIONS.CORE.FETCH_VISIBLE_BRANCHES_FOR_USER](ctx) {
        const r = await yoyoHttp.get('/api/User/GetVisibleBranchesForUser', {
            params: {
                userId: ctx.state.userData.id
            }
        });
        if (r.status === 200) {
            ctx.commit(MUTATIONS.CORE.SET_VISIBLE_BRANCHES_FOR_USER, r.data);
        }
    },

    async [ACTIONS.CORE.SET_CUSTOMER_TRANSACTION_ID](ctx, data) {
        ctx.commit(MUTATIONS.CORE.SET_CUSTOMER_TRANSACTION_ID, data);
    },

    async [ACTIONS.CORE.CHANGE_COMPANY](ctx, companyId) {
        ctx.commit(MUTATIONS.CORE.SET_LOADING, true);
        ctx.commit(
            CREATE_SHIPMENT_PREFIX + MUTATIONS.CREATESHIPMENT.SET_SELECTED_COMPANYID,
            companyId,
            { root: true }
        );
        await ctx.dispatch(ACTIONS.CORE.FETCH_COMPANY_ACCOUNTS);

        await ctx.dispatch(ACTIONS.CORE.FETCH_USER_BRANCH);
        ctx.commit(MUTATIONS.CORE.SET_LOADING, false);
    },

    async [ACTIONS.CORE.CREATE_DOCUMENT_PACK](ctx, request) {
        ctx.commit(MUTATIONS.CORE.SET_LOADING, true);

        const result = await yoyoHttp.post('/api/Print/CreateDocumentPack', request);

        ctx.commit(MUTATIONS.CORE.SET_LOADING, false);

        return result.data;
    },

    async [ACTIONS.CORE.SET_NEWS_SHOWN_FOR_USER](ctx) {
        const request = {
            UserId: ctx.state.userData.id,
            NewsId: ctx.state.news[0].newsId
        };

        await yoyoHttp.post('/api/User/PostSetNewsShownForUser', request);
    },
    async [ACTIONS.UPLOAD_DOCUMENT.FETCH_SHIPMENT_DOCUMENT_TYPES](ctx) {
        const r = await yoyoHttp.cachedGet('/api/StaticData/GetShipmentDocumentTypes', null);

        if (r.status === 200) {
            ctx.commit(MUTATIONS.UPLOAD_DOCUMENT.SET_SHIPMENT_DOCUMENT_TYPES, r.data);
        }
    },

    async [ACTIONS.CORE.FETCH_DAILY_MANIFEST](ctx, request) {
        const r = await yoyoHttp.post('/api/Print/CreateDailyManifest', request);

        return r.data;
    },
    
    async [ACTIONS.CORE.FETCH_COMPANY_ACCOUNTS_BY_COMPANYID](ctx, companyId){
        const r = await yoyoHttp
            .get('/api/User/GetCompanyAccounts', {
                params: {
                    userId: ctx.state.userData.id,
                    companyId: companyId
                }
            }, app.$t('errors.noCompanyAccounts'));
        return r.data;
    },

    async [ACTIONS.CORE.FETCH_COMPANY_ACCOUNTS](ctx) {
        ctx.commit(MUTATIONS.CORE.SET_COMPANY_ACCOUNTS, []);

        const r = await yoyoHttp
            .get('/api/User/GetCompanyAccounts', {
                params: {
                    userId: ctx.state.userData.id,
                    companyId: ctx.rootState.createShipment.selectedCompanyId
                }
            }, app.$t('errors.noCompanyAccounts'));

        if (r.status === 200) {
            ctx.commit(MUTATIONS.CORE.SET_USER_DEFAULT_ACCOUNT, r.data);

            ctx.commit(MUTATIONS.CORE.SET_COMPANY_ACCOUNTS, r.data);

            await ctx.dispatch(
                CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.FETCH_BOOKING_OPTIONS,
                null,
                { root: true }
            );

            await ctx.dispatch(
                CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.FETCH_COMPANY_ACCOUNT_ADDRESSES,
                null,
                { root: true }
            );

            await await ctx.dispatch(
                CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.FETCH_DEFAULT_VALUES,
                null,
                { root: true }
            );
        }
    },
    async [ACTIONS.CORE.FETCH_COMPANIES](ctx) {
        const r = await yoyoHttp.get('/api/User/GetCompanies', {
            params: {
                userId: ctx.state.userData.id
            }
        });
        if (r.status === 200) {
            ctx.commit(MUTATIONS.CORE.SET_COMPANIES, r.data);
        }
    },

    async [ACTIONS.CORE.SET_ACCOUNT](ctx, data) {
        ctx.commit(MUTATIONS.CORE.SET_ACCOUNT, data);
    },
    async [ACTIONS.CORE.FETCH_COUNTRIES](ctx) {
        const r = await yoyoHttp.cachedGet('/api/StaticData/GetCountries', null);
        if (r.status === 200) {
            ctx.commit(MUTATIONS.CORE.SET_COUNTRIES, r.data);
        }
    },
    async [ACTIONS.CORE.FETCH_STATES](ctx) {
        const r = await yoyoHttp.cachedGet('/api/StaticData/GetStateCodes', null);
        if (r.status === 200) {
            ctx.commit(MUTATIONS.CORE.SET_STATECODES, r.data);
        }
    },
    async [ACTIONS.CORE.FETCH_INCOTERMS](ctx) {
        const r = await yoyoHttp.cachedGet('/api/StaticData/GetIncoterms', null);
        if (r.status === 200) {
            ctx.commit(MUTATIONS.CORE.SET_INCOTERMS, r.data);
        }
    },
    [MUTATIONS.CORE.SET_CURRENCY](state, data) {
        state.currencies = data;
    },

    async [ACTIONS.CORE.FETCH_USER_BRANCH](ctx) {
        const r = await yoyoHttp.cachedGet('api/User/GetUserBranch', {
            params: {
                userId: ctx.state.userData.id
            }
        });
        if (r.status === 200) {
            ctx.commit(MUTATIONS.CORE.SET_USER_BRANCH, r.data);
        }
    },
    async [ACTIONS.CORE.FETCH_HEADER_DATA](ctx) {
        const r = await yoyoHttp.cachedGet('api/StaticData/GetHeaderData', {
            params: {
                auth0Id: authService.getUserId(),
                shippingSystem: ctx.state.shipmentSystem
            }
        });

        if (r.status === 200) {
            ctx.commit(MUTATIONS.CORE.SET_HEADER_DATA, r.data);
        }
    },

    async [ACTIONS.CORE.SET_LOADING](ctx, data) {
        ctx.commit(MUTATIONS.CORE.SET_LOADING, data);
    },

    async [ACTIONS.CORE.CHANGE_BOOKINGSYSTEM]({ commit, dispatch }, segmentationCookie) {
        dispatch(ACTIONS.CORE.SET_LOADING, true);

        let shipmentSystemName = allBookingSystems[0].bookingSystemKey;

        if (segmentationCookie !== null) {
            shipmentSystemName = segmentationCookie;
        }
        location.reload()
        dispatch(ACTIONS.CORE.SET_LOADING, false);
    },

    async [ACTIONS.CORE.GET_USER]({ commit, dispatch }) {
        const userResponse = await yoyoHttp.cachedGet('/api/User/GetUser', {
            params: {
                auth0Id: authService.getUserId()
            }
        });

        if (userResponse.status === 200) {
            commit(CORE_PREFIX + MUTATIONS.CORE.SET_USER_DATA, userResponse.data, { root: true });
            commit(
                CREATE_SHIPMENT_PREFIX + MUTATIONS.CREATESHIPMENT.SET_SELECTED_COMPANYID,
                userResponse.data.companyId,
                {
                    root: true
                }
            );
        } else {
            throw new Error('could not get user');
        }
    },

    async [ACTIONS.CORE.FETCH_TRANSPORT_PRODUCTS](ctx) {
        const r = await yoyoHttp.cachedGet('api/StaticData/GetTransportProducts', null);
        if (r.status === 200) {
            ctx.commit(MUTATIONS.CORE.SET_TRANSPORT_PRODUCTS, r.data);
        }
    },

    async [ACTIONS.CORE.INITIALIZE_SYSTEM](ctx) {
        if (ctx.state.initialized) {
            return;
        }

        await ctx.dispatch(CORE_PREFIX + ACTIONS.CORE.FETCH_HEADER_DATA, null, { root: true });
        if (ctx.state.companyAccountId === 0) {
            EventBus.$emit(EVENTS.USER_LOADED);
            await ctx.dispatch(ACTIONS.CORE.FETCH_VISIBLE_BRANCHES_FOR_USER);
            await ctx.dispatch(ACTIONS.CORE.FETCH_COMPANIES);
            await ctx.dispatch(ACTIONS.CORE.FETCH_COUNTRIES);
            await ctx.dispatch(ACTIONS.CORE.FETCH_INCOTERMS);
            await ctx.dispatch(ACTIONS.CORE.FETCH_CURRENCY);
            await ctx.dispatch(ACTIONS.CORE.FETCH_COMPANY_ACCOUNTS);
            await ctx.dispatch(ACTIONS.CORE.FETCH_USER_BRANCH);
            await ctx.dispatch(ACTIONS.CORE.FETCH_TRANSPORT_PRODUCTS);
            await ctx.dispatch(ACTIONS.CORE.FETCH_EXPORT_REASON);
            await ctx.dispatch(ACTIONS.CORE.FETCH_CUSTOMS_FREE_ZONES);
            await ctx.dispatch(ACTIONS.CORE.FETCH_SHIPMENT_SYSTEMS);

            ctx.commit(MUTATIONS.CORE.SET_INITIALIZED, true);
        }
    },
    async [ACTIONS.CORE.FETCH_CURRENCY](ctx) {
        const r = await yoyoHttp.cachedGet('api/StaticData/GetCurrency', null);
        if (r.status === 200) {
            ctx.commit(MUTATIONS.CORE.SET_CURRENCY, r.data);
        }
    },

    async [ACTIONS.CORE.FETCH_EXPORT_REASON](ctx) {
        const r = await yoyoHttp.cachedGet('api/StaticData/GetExportReasonCodes', null);
        if (r.status === 200) {
            ctx.commit(MUTATIONS.CORE.SET_EXPORT_REASON, r.data);
        }
    },

    async [ACTIONS.CORE.FETCH_CUSTOMS_FREE_ZONES](ctx) {
        const r = await yoyoHttp.cachedGet('/api/StaticData/GetCustomsFreeZones', null);

        if (r.status === 200) {
            ctx.commit(MUTATIONS.CORE.SET_CUSTOMS_FREE_ZONES, r.data);
        }
    },

    async [ACTIONS.CORE.FETCH_SHIPMENT_SYSTEMS](ctx) {
        const r = await yoyoHttp.cachedGet('/api/StaticData/GetShipmentSystems', null);

        if (r.status === 200) {
            ctx.commit(MUTATIONS.CORE.SET_SHIPMENT_SYSTEMS, r.data);
        }
    },

    async [ACTIONS.CORE.SET_TEST_USER](ctx, isTestMode) {
        ctx.commit(MUTATIONS.CORE.SET_TEST_USER, isTestMode);
    },

    async [ACTIONS.CORE.INITIALIZE_USER](ctx) {
        if (ctx.state.userLoaded) {
            return;
        }

        let shipmentSystem = 'YOYODenmark';
        var shippingSystemCookie = Vue.$cookies.get('segmentation');
        if (shippingSystemCookie != null) shipmentSystem = shippingSystemCookie;
        yoyoHttp.setHeader("shipmentSystem",shipmentSystem);
        const userResponse = await yoyoHttp.cachedGet('/api/User/GetUser', {
            params: {
                auth0Id: authService.getUserId()
            }, headers: { shipmentSystem: shipmentSystem }
        });

        if (userResponse.status === 200) {
            shipmentSystem = userResponse.data.shipmentSystem;

            ctx.commit(MUTATIONS.CORE.SET_SHIPPING_SYSTEM, shipmentSystem);
            ctx.commit(MUTATIONS.CORE.SET_USER_DATA, userResponse.data);
            ctx.commit(
                CREATE_SHIPMENT_PREFIX + MUTATIONS.CREATESHIPMENT.SET_SELECTED_COMPANYID,
                userResponse.data.companyId,
                {
                    root: true
                }
            );
        } else {
            EventBus.$emit(EVENTS.UNKNOWN_USER);
            console.error('could not get user');
        }
    },


    async [ACTIONS.CORE.INITIALIZE_CREATE_SHIPMENT](ctx) {
        await ctx.dispatch(CORE_PREFIX + ACTIONS.CORE.INITIALIZE_SYSTEM, null, { root: true });
        if (!ctx.rootState.createShipment.initialized) {
            ctx.commit(CREATE_SHIPMENT_PREFIX + MUTATIONS.CREATESHIPMENT.SET_INITIALIZED, null, {
                root: true
            });
            await ctx.dispatch(ACTIONS.CORE.FETCH_NEWS);
            await ctx.dispatch(ACTIONS.CORE.FETCH_COUNTRIES);
            await ctx.dispatch(ACTIONS.CORE.FETCH_STATES);
            await ctx.dispatch(ACTIONS.CORE.FETCH_INCOTERMS);

            await ctx.dispatch(
                CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.FETCH_BOOKING_OPTIONS,
                null,
                { root: true }
            );

            await ctx.dispatch(
                CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.FETCH_COMPANY_ACCOUNT_ADDRESSES,
                null,
                { root: true }
            );

            await ctx.dispatch(
                CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.FETCH_DEFAULT_VALUES,
                null,
                { root: true }
            );
        }
    }
};

export default actions;
